/**
 * Check if array contains some (or each) of value
 * @param {Array} array
 * @param {Array} values
 * @param {boolean} allValuesRequired
 * @returns {boolean}
 */
const contains = (array = [], values = [], allValuesRequired = false) => {
  if (!array || !values) {
    return false;
  }

  if (allValuesRequired) {
    return values.every(value => array.indexOf(value) >= 0);
  }

  return array.some(item => values.indexOf(item) >= 0);
};

export default contains;
